import { DotLegalHeader, DotLegalPdfBackPage, DotLegalSwitch } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ProcessingActivityCountWiget from "../processingActivityCountWidget/ProcessingActivityCountWiget";
import SystemsCountWidget from "../systemsCountWidget/SystemsCountWidget";
import VendorsCountWidget from "../vendorsCountWidget/VendorsCountWidget";
import TasksCountWidget from "../tasksCountWidget/TasksCountWidget";
import IncidentLogWidget from "../incidentLogWidget/IncidentLogWidget";
import { useSetPdfPageSize } from "../../common/pdfPageSizeHelper";
import TasksWidgetReport from "./tasksWidgetReport/TasksWidgetReport";
import ComplianceReportRiskSection from "./complianceReportRiskSection/ComplianceReportRiskSection";
import LatestAuditsSubmittedWidgetReport from "./latestAuditsSubmittedWidgetReport/LatestAuditsSubmittedWidgetReport";
import TasksOverviewWidgetReport from "./tasksOverviewWidgetReport/TasksOverviewWidgetReport";
import PdfReportFrontPage from "@common/PdfReportFrontPage";
import useComplianceReportHooks from "./ComplianceReport.hooks";

function ComplianceReport() {
    const { translateString } = useTranslation();
    const { data } = useComplianceReportHooks();
    useSetPdfPageSize("landscape");

    return (
        <>
            {data && (
                <Box>
                    <PdfReportFrontPage title={translateString("complianceReport")} orientation="landscape" />
                    <Box mt={2} ml={2} mr={2}>
                        <DotLegalHeader headerStyle={"xxxl"}>
                            <Box sx={{ textTransform: "capitalize" }} component={"span"}>
                                {translateString("complianceReport")}
                            </Box>
                        </DotLegalHeader>
                        {data.note && (
                            <Box sx={{ whiteSpace: "pre-wrap" }}>
                                <DotLegalHeader fontWeight={400} fontStyle="italic" headerStyle={"large"}>
                                    {translateString("note")}: {data.note}
                                </DotLegalHeader>
                            </Box>
                        )}

                        <DotLegalSwitch checked={data.onlyUserSpecific} leftLabel={translateString("all")} rightLabel={translateString("my")} />

                        <Box
                            sx={{
                                paddingBottom: 2,
                                paddingTop: 2,
                                paddingLeft: 1,
                                paddingRight: 1,
                                marginTop: 2,
                                backgroundColor: "#EEEFFA",
                                borderRadius: "20px",
                                mb: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <ProcessingActivityCountWiget
                                        isPdf
                                        onlyUserSpecific={data.onlyUserSpecific}
                                        selectedGroupCompany={data.selectedGroupEntity}
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <SystemsCountWidget isPdf onlyUserSpecific={data.onlyUserSpecific} />
                                </Grid>
                                <Grid size={6}>
                                    <VendorsCountWidget isPdf onlyUserSpecific={data.onlyUserSpecific} />
                                </Grid>
                                <Grid size={6}>
                                    <TasksCountWidget isPdf onlyUserSpecific={data.onlyUserSpecific} selectedGroupCompany={data.selectedGroupEntity} />
                                </Grid>
                            </Grid>
                        </Box>

                        <div className="page-break-before">
                            <Box mt={2}>
                                <Grid container spacing={2}>
                                    <Grid size={6}>
                                        <TasksWidgetReport
                                            onlyUserSpecific={data.onlyUserSpecific}
                                            selectedGroupCompany={data.selectedGroupEntity}
                                            showCurrentMonth={false}
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <TasksWidgetReport
                                            onlyUserSpecific={data.onlyUserSpecific}
                                            selectedGroupCompany={data.selectedGroupEntity}
                                            showCurrentMonth
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                        <ComplianceReportRiskSection onlyUserSpecific={data.onlyUserSpecific} selectedGroupCompany={data.selectedGroupEntity} />
                        <div className="page-break-before">
                            <Box mt={2}>
                                <Grid container columnSpacing={2} rowSpacing={1}>
                                    <Grid size={6}>
                                        <LatestAuditsSubmittedWidgetReport
                                            onlyUserSpecific={data.onlyUserSpecific}
                                            selectedGroupCompany={data.selectedGroupEntity}
                                            isAudits
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <LatestAuditsSubmittedWidgetReport
                                            onlyUserSpecific={data.onlyUserSpecific}
                                            selectedGroupCompany={undefined}
                                            isAudits={false}
                                        />
                                    </Grid>
                                    <Grid sx={{ height: 390 }} size={12}>
                                        <TasksOverviewWidgetReport
                                            onlyUserSpecific={data.onlyUserSpecific}
                                            selectedGroupCompany={data.selectedGroupEntity}
                                            year={2024}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                        <div className="page-break-before">
                            <Box mt={2}>
                                <Grid container>
                                    <Grid height={350} size={6}>
                                        <IncidentLogWidget isPdf />
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                    </Box>
                    <div className="page-break-before">
                        <DotLegalPdfBackPage />
                    </div>
                </Box>
            )}
        </>
    );
}

export default ComplianceReport;
